import React, { lazy } from 'react';

import { ServiceNotAvailableState } from '@lumapps/lumx-states/components/ServiceNotAvailableState';
import { Suspense } from '@lumapps/lumx-suspense/components/Suspense';
import { LoadingState } from '@lumapps/micro-apps/components/AdaptiveCard/LoadingState';

import type { FileListIntegratedProps } from './FileListIntegrated';

const LazyFileListIntegrated = lazy(
    () =>
        import(
            /* webpackChunkName: 'file-list-lumapps-component' */
            './FileListIntegrated'
        ),
);

/**
 * FileListIntegrated component that lazily loads the FileListIntegrated implementation.
 * It displays a loading state while the component is loading and a service not available state if there is an error.
 */
export const FileListIntegrated: React.FC<FileListIntegratedProps> = (props) => (
    <Suspense loadingFallback={<LoadingState />} errorFallback={<ServiceNotAvailableState />}>
        <LazyFileListIntegrated {...props} />
    </Suspense>
);
